<template>
  <div class="label" :class="formGroupClass">
    <div class="label-title">
      {{title}}
      <span v-if="isFieldRequired" class="rm">*</span>
    </div>
    <slot></slot>
     
    <validate-prompt :validate-options="fieldValidateObj" :field="title"/>
  </div>
</template>
<script>
import ValidatePrompt from "@/components/ValidatorPrompt.vue";
export default {
  name: "form-group",
  components: {
    ValidatePrompt
  },
  props: {
    title: {
      type: String,
      required: true
    },
    fieldValidateObj: {
      type: Object,
      required: true
    },
    customClass: {
      type: String,
      required: false
    } 
  },
  computed: {
    isFieldRequired() {
      // debugger;
      if (!this.fieldValidateObj) {
        return false;
      } else if (!this.fieldValidateObj.$params) {
        return false;
      } else if (typeof this.fieldValidateObj.$params === "undefined") {
        return false;
      } else if (typeof this.fieldValidateObj.$params.required === "object") {
        return true;
      } else {
        return false;
      }
    },
    hasError() {
      if (this.fieldValidateObj.$error === true) {
        return true;
      } else if (this.fieldValidateObj.$error === false) {
        return false;
      } else {
        return undefined;
      }
    },
    formGroupClass() {
      var hasError = this.hasError;
      var classList = {
        "form-group-error": hasError,
        "form-group-success": hasError === false
      };
      if (this.customClass) {
        var temp = this.customClass.split(" ");
        temp.forEach(name => {
          if (name) {
            classList[name] = true;
          }
        });
      }

      return classList;
    }
  },
  created() {
    // console.log('create-form-group:'+this.title)
    // console.log(this.fieldValidateObj)
  }
};
</script>

<style lang="less">
em ,.rm{
  color: red;
}
.form-group-error {
  > span {
    color: darken(red,10%) !important;
  }
  .label-title,
  .radio,
  .checkbox{
    color: darken(red,10%) !important;
  }
  input[type="text"],
  input[type="number"],
  input[type="email"],
  input[type="date"],
  input[type="datetime"],
  
  select,
  textarea {
    color: darken(red, 10%) !important;
    background-color: lighten(lightcoral, 20%) !important;

    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: #333;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      color: #ddd;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      color: #ddd;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: #ddd;
    }
  }
  .field-error {
    color: darken(red, 5);
  }
}
</style>
